<template>
  <div class="page">
    <yy-header />
    <swiper class="swiper-container swiper-no-swiping" ref="mySwiper" :options="swiperOptions">
      <swiper-slide class="swiper-slide swiper-slide-1">
        <img class="main animate__zoomIn animate__animated" :class="{ active: animated[0] }" src="@/assets/images-front/index-banner-1-main.png" />
      </swiper-slide>
      <swiper-slide class="swiper-slide swiper-slide-2">
        <img class="main animate__rotateIn animate__animated" :class="{ active: animated[1] }" src="@/assets/images-front/index-banner-2-main.png" />
      </swiper-slide>
      <swiper-slide class="swiper-slide swiper-slide-3">
        <img class="main animate__fadeInBottomLeft animate__animated" :class="{ active: animated[2] }" src="@/assets/images-front/index-banner-3-main.png" />
        <yy-footer />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import yyHeader from '../components/yy-header';
import yyFooter from '../components/yy-footer';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import 'animate.css';

export default {
  components: { yyHeader, yyFooter, Swiper, SwiperSlide },

  data() {
    let _this = this;
    return {
      animated: [true, false, false],
      swiperOptions: {
        speed: 800,
        direction: 'vertical',
        slidesPerView: 1,
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        on: {
          slideChangeTransitionEnd: function () {
            _this.animated = [false, false, false];
            _this.animated[this.activeIndex] = true;
            _this.$forceUpdate();
          },
        },
      },
    };
  },

  methods: {},
};
</script>

<style scoped lang="scss">
.swiper-container {
  width: 100%;
  height: 100vh;
  margin-left: auto;
  margin-right: auto;
}
.swiper-pagination /deep/ .swiper-pagination-bullet {
  background: #fff;
  width: 6px;
  height: 6px;
  margin: 15px 10px;
  opacity: 1;
}
.swiper-pagination /deep/ .swiper-pagination-bullet-active {
  width: 6px;
  height: 6px;
  position: relative;
}
.swiper-pagination /deep/ .swiper-pagination-bullet-active:before {
  content: '';
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 100%;
  border: 1px solid #fff;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.swiper-slide {
  background: #fff;
  width: 100%;
  height: 100vh;
  position: relative;
}
.swiper-slide-1 {
  background: url('../../assets/images-front/index-banner-1.jpg') center center no-repeat;
  background-size: cover;
  transform: translateZ(0);
}
.swiper-slide-2 {
  background: url('../../assets/images-front/index-banner-2-1.jpg') center center no-repeat;
  background-size: cover;
  transform: translateZ(0);
}
.swiper-slide-3 {
  background: url('../../assets/images-front/index-banner-3.jpg') center center no-repeat;
  background-size: cover;
  transform: translateZ(0);
}
.swiper-slide .main {
  display: none;
  transform: translateZ(0);
}
.swiper-slide .active {
  display: block;
}
.swiper-slide-1 .main {
  width: 540px;
  margin: 160px auto 0 auto;
}
.swiper-slide-2 .main {
  width: 1200px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -200px 0 0 -600px;
}
.swiper-slide-3 .main {
  width: 926px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -307px 0 0 -458px;
}
</style>
